import React from "react";

interface PageHeaderProps {
  title: string;
  breadcrumb: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, breadcrumb }) => {
  return (
    <header className="bg-white sticky top-0 z-10 shadow-sm">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">
            {title}
          </h1>
          <div className="text-sm text-gray-500">
            <span>Home</span>
            <span className="mx-2">&rarr;</span>
            <span className="font-semibold text-indigo-600">{breadcrumb}</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default PageHeader; 